import { transitionEnd, repaint } from 'utils/node';

export default class Overlay {
  public element: HTMLDivElement;

  private readonly classes: { active: string };

  private classList: string;

  private isActive: boolean;

  constructor(node: HTMLElement = document.body, classList?: string) {
    this.classes = {
      active: 'overlay--active',
    };

    this.classList = classList;
    this.isActive = false;
    this.element = this.create.call(this, node);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  create(holder: HTMLElement) {
    const temp = document.createElement('div');
    temp.hidden = true;
    temp.classList.add('overlay');

    if (this.classList) {
      const list = this.classList.split(' ');
      temp.classList.add(...list);
    }

    holder.appendChild(temp);
    return temp;
  }

  toggle(): void {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(index: number = null): void {
    this.isActive = true;

    this.element.hidden = false;
    if (index !== null) {
      this.element.style.zIndex = index.toString();
    }
    repaint(this.element);
    this.element.classList.add(this.classes.active);
  }

  hide(): void {
    this.isActive = false;
    this.element.classList.remove(this.classes.active);

    transitionEnd(this.element, () => {
      if (this.isActive === false) {
        this.element.hidden = true;
        this.element.style.zIndex = null;
      }
    }, { once: true });
  }
}
